/**
 * SupportedLanguages - matches the SupportedLanguages enum from the OpenAPI schema
 * This should be kept in sync with common/schema/services/account.yaml
 */
export const SupportedLanguages = {
  en: 'en',
  it: 'it',
} as const;

export type SupportedLanguages = (typeof SupportedLanguages)[keyof typeof SupportedLanguages];

export const SUPPORTED_LANGUAGES = Object.values(SupportedLanguages) as readonly SupportedLanguages[];

export const DEFAULT_LANGUAGE: SupportedLanguages = SupportedLanguages.en;
